export default "__VITE_ASSET__DqTn$AEW__"